"use strict";
// @flow
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_redux_1 = require("react-redux");
var google_map_react_1 = require("google-map-react");
var constants_1 = require("../../../constants");
// TODO refactor this contstat to only constant file
var MapConstants_1 = require("../../_shared/components/map/MapConstants");
var _ = require("lodash");
var MapComponent_1 = require("../../_shared/components/map/MapComponent");
var MapActions_1 = require("../MapActions");
var TIME_RELOAD = 30000;
var MAX_MAP_CALLS = 2;
var LiveMapView = /** @class */ (function (_super) {
    __extends(LiveMapView, _super);
    function LiveMapView(props) {
        var _this = _super.call(this, props) || this;
        _this.state = MapConstants_1.mapInitialState;
        _this.locationsLoaded = false;
        return _this;
    }
    LiveMapView.prototype.componentWillMount = function () {
        var _this = this;
        this.interval = window.setInterval(function () { return _this.reloadRealLocations(); }, TIME_RELOAD);
    };
    LiveMapView.prototype.componentWillReceiveProps = function (newProps) {
        // Only in the first update
        if (!this.locationsLoaded && this.props.locations.length === 0 && newProps.locations.length > 0) {
            this.locationsLoaded = true;
            this.fitBounds(newProps.locations.map(function (location) { return ({
                longitude: location.wx,
                latitude: location.wy,
            }); }));
        }
        if (this.gmap && !_.isEqual(this.props.locations, newProps.locations)) {
            this.renderLocations(newProps.locations);
        }
    };
    LiveMapView.prototype.componentWillUnmount = function () {
        clearInterval(this.interval);
    };
    LiveMapView.prototype.reloadRealLocations = function () {
        if (this.props.apiCounter < MAX_MAP_CALLS && this.gMapProps) {
            this.props.getRealLocations(this.gMapProps);
        }
    };
    LiveMapView.prototype.renderLocations = function (locations) {
        var _this = this;
        if (locations === void 0) { locations = []; }
        console.time('renderMarkers:');
        this.clearLocations();
        if (!this.gMapProps) {
            return;
        }
        locations.forEach(function (cluster) {
            if (cluster.numPoints === 1) {
                // Cluster has just 1 point
                var location_1 = __assign({}, cluster.points[0]);
                if (!location_1) {
                    return;
                }
                _this.buildAddressMarker(location_1);
                return;
            }
            _this.buildCluster(cluster);
        });
        console.timeEnd('renderMarkers: Visibility');
    };
    LiveMapView.prototype.onMapLoaded = function (event) {
        this.gmap = event.map;
        this.defaultFitBounds();
        this.renderLocations(this.props.locations);
        this.props.getLocations(this.gMapProps);
    };
    LiveMapView.prototype.onChange = function (map) {
        _super.prototype.onChange.call(this, map);
        this.props.getLocations(map);
    };
    LiveMapView.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "map" },
            React.createElement(google_map_react_1.default, { bootstrapURLKeys: { key: constants_1.GOOGLE_API }, onChange: function (map) { return _this.onChange(map); }, center: this.state.center, zoom: this.state.zoom, onGoogleApiLoaded: function (event) { return _this.onMapLoaded(event); } })));
    };
    return LiveMapView;
}(MapComponent_1.MapComponent));
var mapStateToProps = function (_) {
    return {
        apiCounter: _.reducer.api.lastLocation.activeCalls,
        locations: _.reducer.locationsState.users.concat(_.reducer.locationsState.places),
    };
};
var mapDispatchToProps = function (dispatch) { return ({
    getRealLocations: function (options) { return MapActions_1.MapActions.calculatedLocations(options)(dispatch); },
    getLocations: function (options) { return MapActions_1.MapActions.getLocations(options)(dispatch); },
}); };
exports.default = (0, react_redux_1.connect)(mapStateToProps, mapDispatchToProps)(LiveMapView);
